module.exports = __webpack_public_path__ + "img/team-logo@2x.8d09d923.jpg";